import React, { Component } from 'react';
import { ScrollView, View } from 'react-native';

import {
  VFText,
  VFButton,
  QuickActionMenu,
  VFItem,
  Icon,
} from '@vfgroup-oneplatform/foundation/Components';
import { withTheme, LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes';
import VFLottieView, { LottieTypes } from '@vfgroup-oneplatform/foundation/Components/VFLottieView';
import { map as _map } from 'lodash';
import PropTypes from 'prop-types';

import LoginTestKeys from '../../../Utils/LoginTestKeys';
import RemoveAccountResult from '../RemoveAccountResult/RemoveAccountResult';

import styles from './EditAccount.Styles';

class EditAccount extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
  }

  componentDidUpdate(prevProps) {
    const { isModalVisible } = this.props;
    if (prevProps.isModalVisible !== isModalVisible) {
      if (prevProps.isModalVisible) {
        setTimeout(() => {
          this.restoreInitialState();
        }, 400);
      } else {
        this.restoreInitialState();
      }
    }
  }

  getInitialState = () => ({
    isEditAccountsList: true,
    isConfirmRemoveAccount: false,
    selectedAccount: {},
    isBorderVisible: false,
    isRemoveAccountLoading: false,
    isRemoveAccountFinished: false,
    isRemoveAccountFinishedSuccess: false,
  });

  onDeleteAccountPress = account => {
    this.setState({ selectedAccount: account }, () => {
      this.setState({ isConfirmRemoveAccount: true, isEditAccountsList: false });
    });
  };

  onBackButtonPress = () => {
    this.setState({ isEditAccountsList: true, isConfirmRemoveAccount: false });
  };
  onDeleteAccountConfirmPress = () => {
    this.setState(
      {
        isConfirmRemoveAccount: false,
        isRemoveAccountLoading: true,
        isRemoveAccountFinished: false,
      },
      () => {
        this.handleDeleteAccount();
      },
    );
  };

  onDeleteAccountSuccess = async () => {
    this.setState({
      isRemoveAccountLoading: false,
      isRemoveAccountFinished: true,
      isRemoveAccountFinishedSuccess: true,
    });
  };
  onDeleteAccountFail = () => {
    this.setState({
      isRemoveAccountLoading: false,
      isRemoveAccountFinished: true,
      isRemoveAccountFinishedSuccess: false,
    });
  };
  onScrollHandling = ({ nativeEvent }) => {
    if (nativeEvent.contentOffset.y <= 0) {
      this.setState({
        isBorderVisible: false,
      });
    } else {
      this.setState({
        isBorderVisible: true,
      });
    }
  };
  onReturnToSignInPress = () => {
    this.props.toggleModal();
    this.props.onUpfrontLogin();
  };
  handleDeleteAccount = async () => {
    try {
      await this.props.onDeleteAccount(this.state.selectedAccount);
      this.onDeleteAccountSuccess();
    } catch (error) {
      this.onDeleteAccountFail();
    }
  };

  restoreInitialState = () => {
    this.setState(this.getInitialState());
  };

  render() {
    const {
      isEditAccountsList,
      isConfirmRemoveAccount,
      selectedAccount,
      isBorderVisible,
      isRemoveAccountLoading,
      isRemoveAccountFinished,
      isRemoveAccountFinishedSuccess,
    } = this.state;
    const { isModalVisible, toggleModal, savedAccounts, images, getAccountIconBasedOnType, theme } =
      this.props;
    const isSavedAccountsEmpty = (savedAccounts || []).length === 0;
    return (
      <QuickActionMenu
        isVisible={isModalVisible}
        toggleModal={toggleModal}
        closeModal={isSavedAccountsEmpty ? this.onReturnToSignInPress : toggleModal}
        title={
          isEditAccountsList
            ? 'registered_account_edit_dialog_title'
            : 'registered_account_edit_your_account_list_label'
        }
        titlePlaceholders={[savedAccounts.length]}
        withTitle={isConfirmRemoveAccount ? false : true}
        headerStyle={styles.quickActionMenuHeaderStyle}
        type="secondary"
        withCloseButton={!isRemoveAccountLoading}
        quickActionMenuCloseIconTestID={LoginTestKeys.quickActionCloseIcon}
      >
        {isEditAccountsList ? (
          <View>
            <VFText
              style={styles.mainText(theme)}
              i18nKey={'registered_account_edit_your_account_list_label'}
              testID={LoginTestKeys.editSavedAccountsSubtitle}
            />
            <ScrollView
              style={[
                styles.scrollViewStyle,
                isBorderVisible ? styles.scrollViewBorder(theme) : {},
              ]}
              onScroll={this.onScrollHandling}
              scrollEventThrottle={20}
              nestedScrollEnabled={true}
              contentContainerStyle={styles.scrollViewContent}
            >
              {_map(savedAccounts, (account, index) => (
                <VFItem
                  {...account}
                  leftIcon={images[getAccountIconBasedOnType(account.accountType)]}
                  rightIcon={images.ic_close_circle}
                  leftIconSize={33}
                  rightIconSize={33}
                  nameTextStyle={styles.accountNameText}
                  onRightIconPress={() => this.onDeleteAccountPress(account)}
                  images={images}
                />
              ))}
            </ScrollView>
            <VFText style={styles.subText(theme)} i18nKey={'registered_account_edit_dialog_hint'} />
            <VFButton
              style={styles.primaryButton}
              title={'registered_account_edit_dialog_button'}
              onPress={toggleModal}
              testKey={LoginTestKeys.returnToSignIn}
            />
          </View>
        ) : null}
        {isConfirmRemoveAccount ? (
          <View>
            <View style={styles.modalIconContainer}>
              <Icon name={images.ic_user} type="image" style={styles.iconContainer} />
            </View>
            <VFText
              i18nKey={'confirm_remove_account_remove_account_label'}
              placeHolders={[selectedAccount.name]}
              style={styles.modalMessage(theme)}
            />
            <VFText
              i18nKey={selectedAccount.phoneNumberOrEmail}
              style={styles.modalDescription(theme)}
            />
            <VFButton
              title={'confirm_remove_account_remove_account_button'}
              style={styles.modalButton}
              textStyle={styles.modalButtonText}
              type={'primary'}
              onPress={this.onDeleteAccountConfirmPress}
              testKey={LoginTestKeys.removeAccountBtn}
            />
            <VFButton
              title={'confirm_remove_account_back_button'}
              style={styles.modalButton}
              textStyle={styles.modalButtonText}
              type={'secondary'}
              onPress={this.onBackButtonPress}
              testKey={LoginTestKeys.backBtn}
            />
          </View>
        ) : null}
        {isRemoveAccountLoading && (
          <View style={styles.loadingContainer}>
            <VFLottieView
              autoPlay
              style={styles.loadingLottieView}
              type={LottieTypes.spinner}
              loop={true}
            />
            <VFText
              style={styles.loadingTitle(theme)}
              i18nKey={'confirm_remove_account_removing_account_label'}
              placeHolders={[selectedAccount.name]}
            />
          </View>
        )}
        {isRemoveAccountFinished && (
          <RemoveAccountResult
            savedAccounts={savedAccounts}
            onDeleteAccountConfirmPress={this.onDeleteAccountConfirmPress}
            isRemoveAccountFinishedSuccess={isRemoveAccountFinishedSuccess}
            selectedAccount={selectedAccount}
            onReturnToAccountsPress={this.restoreInitialState}
            onReturnToSignInPress={this.onReturnToSignInPress}
          />
        )}
      </QuickActionMenu>
    );
  }
}

EditAccount.defaultProps = {
  theme: LightThemeColors,
  savedAccounts: [],
  isModalVisible: false,
};

EditAccount.propTypes = {
  theme: PropTypes.object,
  isModalVisible: PropTypes.bool,
  toggleModal: PropTypes.func,
  savedAccounts: PropTypes.array,
  images: PropTypes.object,
  getAccountIconBasedOnType: PropTypes.func,
  onDeleteAccount: PropTypes.func,
  onUpfrontLogin: PropTypes.func,
};

export default withTheme(EditAccount);
